/**
 * Iridium Collector API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec, HttpContext 
        }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

// @ts-ignore
import { InformationGroupedByDevice } from '../model/informationGroupedByDevice';
// @ts-ignore
import { IridiumMessage } from '../model/iridiumMessage';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';



@Injectable({
  providedIn: 'root'
})
export class IridiumCollectorDbReaderControllerService extends BaseService {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * @param page 
     * @param count 
     * @param orderBy 
     * @param orderDirection 
     * @param idDeviceList 
     * @param comIdList 
     * @param afterScts 
     * @param beforeScts 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getData(page: number, count: number, orderBy: string, orderDirection: string, idDeviceList?: Array<number>, comIdList?: Array<string>, afterScts?: string, beforeScts?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Array<IridiumMessage>>;
    public getData(page: number, count: number, orderBy: string, orderDirection: string, idDeviceList?: Array<number>, comIdList?: Array<string>, afterScts?: string, beforeScts?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Array<IridiumMessage>>>;
    public getData(page: number, count: number, orderBy: string, orderDirection: string, idDeviceList?: Array<number>, comIdList?: Array<string>, afterScts?: string, beforeScts?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Array<IridiumMessage>>>;
    public getData(page: number, count: number, orderBy: string, orderDirection: string, idDeviceList?: Array<number>, comIdList?: Array<string>, afterScts?: string, beforeScts?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (page === null || page === undefined) {
            throw new Error('Required parameter page was null or undefined when calling getData.');
        }
        if (count === null || count === undefined) {
            throw new Error('Required parameter count was null or undefined when calling getData.');
        }
        if (orderBy === null || orderBy === undefined) {
            throw new Error('Required parameter orderBy was null or undefined when calling getData.');
        }
        if (orderDirection === null || orderDirection === undefined) {
            throw new Error('Required parameter orderDirection was null or undefined when calling getData.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (idDeviceList) {
            idDeviceList.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'idDeviceList');
            })
        }
        if (comIdList) {
            comIdList.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'comIdList');
            })
        }
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>afterScts, 'afterScts');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>beforeScts, 'beforeScts');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>page, 'page');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>count, 'count');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>orderBy, 'orderBy');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>orderDirection, 'orderDirection');

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/messages/data`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Array<IridiumMessage>>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param idDeviceList 
     * @param comIdList 
     * @param afterScts 
     * @param beforeScts 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getDataCount(idDeviceList?: Array<number>, comIdList?: Array<string>, afterScts?: string, beforeScts?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<number>;
    public getDataCount(idDeviceList?: Array<number>, comIdList?: Array<string>, afterScts?: string, beforeScts?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<number>>;
    public getDataCount(idDeviceList?: Array<number>, comIdList?: Array<string>, afterScts?: string, beforeScts?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<number>>;
    public getDataCount(idDeviceList?: Array<number>, comIdList?: Array<string>, afterScts?: string, beforeScts?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (idDeviceList) {
            idDeviceList.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'idDeviceList');
            })
        }
        if (comIdList) {
            comIdList.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'comIdList');
            })
        }
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>afterScts, 'afterScts');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>beforeScts, 'beforeScts');

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/messages/data/count`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<number>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param page 
     * @param count 
     * @param orderBy 
     * @param orderDirection 
     * @param idDeviceList 
     * @param comIdList 
     * @param afterScts 
     * @param beforeScts 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getInformationGroupedByDevice(page: number, count: number, orderBy: string, orderDirection: string, idDeviceList?: Array<number>, comIdList?: Array<string>, afterScts?: string, beforeScts?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Array<InformationGroupedByDevice>>;
    public getInformationGroupedByDevice(page: number, count: number, orderBy: string, orderDirection: string, idDeviceList?: Array<number>, comIdList?: Array<string>, afterScts?: string, beforeScts?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Array<InformationGroupedByDevice>>>;
    public getInformationGroupedByDevice(page: number, count: number, orderBy: string, orderDirection: string, idDeviceList?: Array<number>, comIdList?: Array<string>, afterScts?: string, beforeScts?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Array<InformationGroupedByDevice>>>;
    public getInformationGroupedByDevice(page: number, count: number, orderBy: string, orderDirection: string, idDeviceList?: Array<number>, comIdList?: Array<string>, afterScts?: string, beforeScts?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (page === null || page === undefined) {
            throw new Error('Required parameter page was null or undefined when calling getInformationGroupedByDevice.');
        }
        if (count === null || count === undefined) {
            throw new Error('Required parameter count was null or undefined when calling getInformationGroupedByDevice.');
        }
        if (orderBy === null || orderBy === undefined) {
            throw new Error('Required parameter orderBy was null or undefined when calling getInformationGroupedByDevice.');
        }
        if (orderDirection === null || orderDirection === undefined) {
            throw new Error('Required parameter orderDirection was null or undefined when calling getInformationGroupedByDevice.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (idDeviceList) {
            idDeviceList.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'idDeviceList');
            })
        }
        if (comIdList) {
            comIdList.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'comIdList');
            })
        }
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>afterScts, 'afterScts');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>beforeScts, 'beforeScts');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>page, 'page');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>count, 'count');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>orderBy, 'orderBy');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>orderDirection, 'orderDirection');

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/messages/groupedByDevice`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Array<InformationGroupedByDevice>>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param idDeviceList 
     * @param comIdList 
     * @param afterScts 
     * @param beforeScts 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getInformationGroupedByDeviceCount(idDeviceList?: Array<number>, comIdList?: Array<string>, afterScts?: string, beforeScts?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<number>;
    public getInformationGroupedByDeviceCount(idDeviceList?: Array<number>, comIdList?: Array<string>, afterScts?: string, beforeScts?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<number>>;
    public getInformationGroupedByDeviceCount(idDeviceList?: Array<number>, comIdList?: Array<string>, afterScts?: string, beforeScts?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<number>>;
    public getInformationGroupedByDeviceCount(idDeviceList?: Array<number>, comIdList?: Array<string>, afterScts?: string, beforeScts?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (idDeviceList) {
            idDeviceList.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'idDeviceList');
            })
        }
        if (comIdList) {
            comIdList.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'comIdList');
            })
        }
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>afterScts, 'afterScts');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>beforeScts, 'beforeScts');

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/messages/groupedByDevice/count`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<number>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

}
